<template>
    <div v-bind:class="{'btn-disabled': disabled, 'btn-big': big}" @click="buttonPressedEvent">
        <img :src="icon" v-bind:class="{'btn-big-img': big, 'black': black}">
    </div>
</template>

<script>
export default {
    name: 'CircleButton',
    props: [
        'icon',
        'disabled',
        'big',
        'black',
        'evetName'
    ],
    methods: {
        buttonPressedEvent: function () {
            if (this.evetName) {
                this.$emit(this.evetName)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    div {
        width: 3rem;
        height: 3rem;
        border: none;
        outline: none;
        color: @white;
        border-radius: 45px;
        background: @gradient-color;
    }

    .btn-disabled {
        color: @black;
        background: @disabled-color;
    }

    .btn-big {
        width: 4.5rem;
        height: 4.5rem;
    }

    .btn-big-img {
        width: 3.5rem;
    }

    .black {
        filter: brightness(0);
    }

    img {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: relative;
        width: 2rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/CircleButtonWithNamedEvent.vue